import { render, staticRenderFns } from "./BestCarousel.vue?vue&type=template&id=2399cdfa&scoped=true&"
import script from "./BestCarousel.vue?vue&type=script&lang=js&"
export * from "./BestCarousel.vue?vue&type=script&lang=js&"
import style0 from "./BestCarousel.vue?vue&type=style&index=0&id=2399cdfa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2399cdfa",
  null
  
)

export default component.exports